Namespace 'Common'

class Common.SelectView extends Backbone.View
  template: JST['backbone/templates/common/select']
  optionTemplate: JST['backbone/templates/common/select_option']
  tagName: 'select'
  className: 'select'

  initialize: ({options, selectedOption}) ->
    @options = options
    @selectedOption = selectedOption

  render: ->
    for option in @options
      @$el.append @optionTemplate
        label: option.label
        value: option.value
    @$el.val(@selectedOption)
    @

  getSelectedOption: ->
    selectedOption = @getSelectedValue()
    @options.find((option) -> "#{option.value}" == selectedOption)

  getSelectedValue: ->
    @$el.find('option:selected').val()

  toggleSelector: (enable) ->
    @$el.prop('disabled', not enable)
